// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[dir=ltr] .dropdown-text[data-v-0ac8fd01] {\n  margin-left: 5px;\n}[dir=rtl] .dropdown-text[data-v-0ac8fd01] {\n  margin-right: 5px;\n}", ""]);
// Exports
module.exports = exports;
